import {
  addCommasToNumber,
  DifferenceCell,
  GraviGrid,
  NetValueCell,
  NumberCell,
  Texto,
  Vertical,
} from '@gravitate-js/excalibrr'
import moment from 'moment'
import React, { useCallback, useMemo } from 'react'
import { formatters } from '@utils/intl/dateTimeFormatters'
import { defaultNumberDef } from '@components/_SiteWide/CellTemplates/typeColumnDefs'
import { useUserSettings } from '@hooks/settings'

export function DirectiveLoadedGrid({ directiveMetrics, metricsLoading }) {
  const metricsWithLoadedDiff = useMemo(() =>
    directiveMetrics.directive_by_day.map((row) => {
      if (row.min && row.max) {
        if (row.loaded > row.min) {
          row.loaded_difference = row.loaded > row.max ? row.loaded - row.max : 0
        } else {
          row.loaded_difference = row.loaded - row.min
        }
      } else if (row.max) {
        row.loaded_difference = row.loaded > row.max ? row.loaded - row.max : 0
      } else {
        row.loaded_difference = 0
      }
      row.loaded = moment(row.date).isAfter(moment().startOf('day')) ? null : row.loaded
      return row
    })
  )
  const { updateSetting } = useUserSettings()
  const getRowId = useCallback((row) => row.data?.date, [])
  const columnDefs = useMemo(() => getColumnDefs(), [])
  const agPropOverrides = useMemo(
    () => ({
      frameworkComponents: {
        numberCell: NumberCell,
        differenceCell: DifferenceCell,
        netValueCell: NetValueCell,
      },
      singleClickEdit: true,
      rowHeight: 30,
      getRowId,
    }),
    []
  )

  return (
    <Vertical flex={1}>
      <GraviGrid
        storageKey='directivesLoaded'
        rowData={metricsWithLoadedDiff}
        agPropOverrides={agPropOverrides}
        columnDefs={columnDefs}
        loading={metricsLoading}
        onGridConfigChanged={(config) => updateSetting('gridConfig::directivesLoaded', config)}
      />
    </Vertical>
  )
}

const getColumnDefs = () => [
  {
    headerName: 'Date',
    field: 'date',
    editable: 'false',
    valueFormatter: ({ value }) => formatters.DATE(moment(value)),
  },
  {
    headerName: 'Net Value',
    field: 'net_cost',
    cellRenderer: 'netValueCell',
  },
  {
    headerName: 'Loaded',
    field: 'loaded',
    cellRenderer: 'differenceCell',
    cellRendererParams: { comparisonKey: 'loaded_difference', showCheck: true, upIsError: true },
  },
  {
    headerName: 'Dir. Min',
    field: 'min',
    ...defaultNumberDef('min', 0),
    cellRenderer: ({ value }) => (
      <Texto weight={'bold'} align={'right'}>
        {value || value === 0 ? addCommasToNumber(value, 0) : 'N/A'}
      </Texto>
    ),
  },
  {
    headerName: 'Dir. Max',
    field: 'max',
    ...defaultNumberDef('max', 0),
    cellRenderer: ({ value }) => (
      <Texto weight={'bold'} align={'right'}>
        {value || value === 0 ? addCommasToNumber(value, 0) : 'N/A'}
      </Texto>
    ),
  },
]
